export const getJobTitle = `query getJobTitle ($input: TJobTitleWhereInput!, $skip: Float, $take: Float) {
    getJobTitle (where: $input, skip: $skip, take: $take,orderBy:{createDate:DESC} ) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            id
            jobName
            roleId
            trole{
                id
                name
            }
        }
    }
}`;
export const updateJobTitle = `mutation updateJobTitle ($input: TJobTitleInput!) {
     updateJobTitle(input: $input) {
       id
       jobName
       roleId
    }
}`;
export const GET_JOBTITLE_COMBOBOX = `query getJobTitle ($input: TJobTitleWhereInput!, $skip: Float, $take: Float) {
    getJobTitle (where: $input, skip: $skip, take: $take,orderBy:{createDate:DESC} ) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
        items {
            id
            jobName
            roleId
        }
    }
}`;
